import { transliterateCyrillic } from '../../../utils/utm/transliterateCyrillic'

/**
 * Product name → latin slug (parity with functions/products/productSlug.js).
 */
export function slugifyProductName(value = '') {
  const transliterated = transliterateCyrillic(String(value))
    .trim()
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')

  return transliterated
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .replace(/-+/g, '-')
}

export function isValidProductSlug(slug) {
  if (typeof slug !== 'string' || !slug) return false
  return /^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(slug)
}

export function getProductSlugReviewMessage(reason) {
  if (reason === 'empty_base') {
    return 'Назва товару не дозволила сформувати коректний slug'
  }
  if (reason === 'collision' || reason === 'collision_exhausted') {
    return 'Slug уже використовується іншим товаром'
  }
  return 'Перевірте та збережіть slug вручну'
}
